import {
  addApartment,
  addArea,
  addCostUnit,
  addDataByKey,
  getApartment,
  getApartments,
  getArea,
  getAreas,
  getCostUnit,
  getCostUnits,
  getDataByKey,
  hasApartment,
  hasArea,
  hasCostUnit,
  hasDataByKey,
  removeApartment,
  removeArea,
  removeCostUnit,
  removeDataByKey,
} from "./hoasFavouritesApi";
import { initializeAllFavouriteButtons } from "./hoasFavouritesDom";
import {
  APARTMENT_KEY,
  AREA_KEY,
  constructApartmentName,
  COSTUNIT_KEY,
  createApartmentObject,
  createCostUnitObject,
  formIsEditForm,
  getParsedObject,
  isEditAttachments,
} from "./hoasFavouritesHelpers";

const hoasFavouritesApi = function () {
  /**
   * Initializes favourites system
   */
  const initializeFavouritesDOM = () => {
    // Initialize normal favourites
    initializeAllFavouriteButtons();
  };

  window.hoasFavourites = {
    initializeFavouritesDOM: initializeFavouritesDOM,
    // Generic functions that check from object.type the localstorage key
    hasDataByKey: hasDataByKey,
    addDataByKey: addDataByKey,
    getDataByKey: getDataByKey,
    removeDataByKey: removeDataByKey,

    // Apartment logic
    addApartment: addApartment,
    removeApartment: removeApartment,
    hasApartment: hasApartment,
    getApartment: getApartment,

    // CostUnit logic
    addCostUnit: addCostUnit,
    removeCostUnit: removeCostUnit,
    hasCostUnit: hasCostUnit,
    getCostUnit: getCostUnit,

    // Area logic
    addArea: addArea,
    removeArea: removeArea,
    hasArea: hasArea,
    getArea: getArea,

    // Get all results from localstorage
    getApartments: getApartments,
    getCostUnits: getCostUnits,
    getAreas: getAreas,

    // Create localstorage objects
    createCostUnitObject: createCostUnitObject,
    createApartmentObject: createApartmentObject,

    // Helpers
    formIsEditForm: formIsEditForm,
    isEditAttachments: isEditAttachments,
    getParsedObject: getParsedObject,
    constructApartmentName: constructApartmentName,
    // Constants
    AREA_KEY: AREA_KEY,
    APARTMENT_KEY: APARTMENT_KEY,
    COSTUNIT_KEY: COSTUNIT_KEY,
  };
};

hoasFavouritesApi();
